import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <img src="/logo.png" alt="Janki's Cloud Kitchen" className={styles.logoImage} />
          {/* <div>
            <h1 className={styles.logoText}>Janki's Cloud Kitchen</h1>
            <p className={styles.logoSubtext}>PURE,FRESH & TRULY HOMEMADE</p>
          </div> */}
        </Link>

        <button 
          className={styles.mobileMenuBtn}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.mobileMenuOpen : ''}`}>
          <Link 
            to="/" 
            className={isActive('/') ? styles.active : ''}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={isActive('/about') ? styles.active : ''}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </Link>
          <Link 
            to="/specials" 
            className={isActive('/specials') ? styles.active : ''}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Specials
          </Link>
          <Link 
            to="/menu" 
            className={isActive('/menu') ? styles.active : ''}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Menu
          </Link>
          <Link 
            to="/contact" 
            className={isActive('/contact') ? styles.active : ''}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact
          </Link>
          {/* <a 
            href="https://wa.me/919601399999" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.orderBtn}
          >
            Order Now
          </a> */}
        </nav>
      </div>
    </header>
  );
};

export default Header;
